import { brands } from '../constants/brands';
const partners = [brands.HOTELIERMART, brands.RCI, brands.ROME2RIO, brands.SERKO, brands.SUBIRTE, brands.TRIPBEAT, brands.TRIPSTACK, brands.WYNDHAM];
export const isPartner = brandCode => partners.some(partner => partner === brandCode);
//# sourceMappingURL=index.js.map